import {
    showItemFirstBidToast,
    showItemOutbiddedToast,
    showItemPaidToast,
    showItemSoldToast,
    showItemWishListReminderToast,
    showItemWonToast
} from './toasts';
import axios from 'axios';
import ENDPOINTS from 'tradera-constants/endpoints';
import { getGlobalSocket } from './global-socket';

const refreshLoginState = async socket => {
    try {
        const response = await axios.get(
            ENDPOINTS.TOUCHWEB_URL + 'login/state'
        );

        if (!response.data?.isLoggedIn) {
            return;
        }

        socket.disconnect();
        socket.connect();
    } catch {
        // Could not get token.
    }
};

export const bootSiteWideNotifications = ({ socketUrl, joinMemberRoom }) => {
    if (!joinMemberRoom) {
        return;
    }

    const socket = getGlobalSocket(socketUrl);
    let isRetry = false;
    socket.on('JoinMemberRoom', async ({ success }) => {
        // To avoid infinite loop
        if (success || isRetry) {
            // eslint-disable-next-line better-mutation/no-mutation
            isRetry = false;
            return;
        }

        // eslint-disable-next-line better-mutation/no-mutation
        isRetry = true;
        await refreshLoginState(socket);
    });
    socket.addEventListener('MemberItemOutbidded', data =>
        showItemOutbiddedToast(data.ItemId, data.NewLeadingBidAmount)
    );
    socket.addEventListener('MemberItemFirstBid', data =>
        showItemFirstBidToast(data.ItemId)
    );
    socket.addEventListener('MemberItemSold', data =>
        showItemSoldToast(data.ItemId, data.Price)
    );
    socket.addEventListener('MemberItemWon', data =>
        showItemWonToast(data.ItemId, data.Price)
    );
    socket.addEventListener('MemberItemPaid', data =>
        showItemPaidToast(data.ItemId)
    );
    socket.addEventListener('MemberItemWishListReminder', data =>
        showItemWishListReminderToast(data.ItemId, data.TimeLeftMinutes)
    );
    socket.join('member');
};
